/**
 * JAVASCRIPT DEVELOPER DOCUMENTATION
 *
 * Symmetry is a powerful and customizable theme designed for large-scale e-commerce stores. Built
 * using Web Components, it offers a highly modular architecture that makes customization and
 * maintenance easier than ever. In addition, Symmetry is optimized for speed, ensuring that your
 * store runs as fast as possible to provide your customers with a seamless shopping experience.
 *
 * If you would like to add your own JS to Symmetry, we recommend using this file and referencing
 * it using Theme Settings > Advanced > Custom HTML.
 *
 * As a brief overview, Symmetry:
 *  - Broadcasts many JS events.
 *  - Is built using Web Components.
 *  - Leverages 'code splitting' for some features.
 *  - Is completely custom built (no JS libraries)
 *  - Has a number of JS utilities.
 *
 * Symmetry broadcasts these custom events (details logged to the console when in the Theme Editor).
 * Events are named ["on"/"dispatch"]:[subject]:[action]. All 'Return data' is within event.detail.
 *
 *  1.  on:variant:change          - fires when a variant is selected (product page, quickbuy, etc).
 *                                   Returns: form, variant, allVariants, selectedOptions.
 *  2.  on:cart:add                - a variant was added to the cart (not already present).
 *                                   Returns: variantId.
 *  3.  on:cart:error              - a cart action failed. Returns: error.
 *  4.  on:cart:after-merge        - the cart item list finished re-rendering.
 *  5.  on:cart-drawer:before-open
 *  6.  on:cart-drawer:after-open
 *  7.  on:cart-drawer:after-close
 *  8.  on:quickbuy:before-open
 *  9.  on:quickbuy:after-open
 *  10. on:quickbuy:after-close
 *  11. dispatch:cart-drawer:open  - opens the cart drawer (optional detail.opener element).
 *  12. dispatch:cart-drawer:refresh
 *  13. dispatch:cart-drawer:close
 *  14. on:debounced-resize        - the viewport finished resizing (300ms debounce).
 *  15. on:breakpoint-change       - the viewport breakpoint changed (see theme.mediaMatches).
 *
 * Listen with document.addEventListener('on:cart:add', (event) => { ... });
 * Trigger with document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
 *
 * Symmetry utilizes Web Components (Custom Elements, Shadow DOM and HTML Templates) throughout,
 * and has no third-party JavaScript dependencies.
 * See Mozilla for more: https://developer.mozilla.org/en-US/docs/Web/Web_Components
 *
 * Have fun! - The Clean Canvas Development Team.
 */

/* ------------------------------------------------------------------
 * Enlaces externos -> se abren en pestana nueva.
 * Los enlaces que apuntan a la propia tienda (incluido el dominio
 * .myshopify.com) se tratan como INTERNOS: se quedan en la misma
 * pestana y se reescriben al dominio actual (sin redireccion extra).
 * ------------------------------------------------------------------ */
(function () {
  var INTERNAL_HOSTS = ['5ab8e1-62.myshopify.com', 'allscrubs.cl', 'www.allscrubs.cl'];

  function fixLinks() {
    var links = document.links;
    for (var i = 0, linksLength = links.length; i < linksLength; i++) {
      var link = links[i];
      var host = link.hostname;

      if (!host || host === window.location.hostname) continue;

      if (INTERNAL_HOSTS.indexOf(host) !== -1) {
        link.href = link.pathname + link.search + link.hash;
        link.removeAttribute('target');
        continue;
      }

      link.target = '_blank';
      link.rel = 'noreferrer noopener';
    }
  }

  fixLinks();
  document.addEventListener('DOMContentLoaded', fixLinks);
  window.addEventListener('load', fixLinks);
})();

/* GLO */

document.addEventListener('DOMContentLoaded', function () {
    function checkStock() {
        // Selecciona todos los elementos de variante de talla dentro del contenedor con data-option-index="1"
        var sizeOptions = document.querySelectorAll('[data-option-index="0"] .globo-swatch-item');

        sizeOptions.forEach(function(option) {
            var variantId = option.getAttribute('data-variant-id'); // Ajusta este atributo segun tu tema y configuracion de GLO Color Swatch
            var variantStock = document.querySelector(`.variant-stock[data-variant-id="${variantId}"]`); // Ajusta este selector segun tu tema

            if (variantStock && parseInt(variantStock.textContent) === 0) {
                option.classList.add('globo-out-of-stock');
            } else {
                option.classList.remove('globo-out-of-stock');
            }
        });
    }

    // Llama a la funcion de verificacion de stock cuando la pagina se carga
    checkStock();

    // Tambien llama a la funcion de verificacion de stock cuando se cambia una opcion de variante
    var variantSelectors = document.querySelectorAll('.single-option-selector');
    variantSelectors.forEach(function(selector) {
        selector.addEventListener('change', checkStock);
    });
});